import { useMerchant } from "@/lib/useMerchant";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardFooter from "@/components/DashboardFooter";
import ShippingInfo from "@/pages/ShippingInfo";

export default function ShippingPage() {
  const { me, loading } = useMerchant();

  if (loading || !me) {
    return (
      <div className="min-h-screen bg-cream">
        <DashboardHeader me={me} />
        <div className="grid h-64 place-items-center text-sm text-ink/50">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <DashboardHeader me={me} />
      <ShippingInfo />
      <DashboardFooter />
    </div>
  );
}
